var React = require('react');

function Exclamation (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M7.2 11c0 .4.4.7.8.7.5 0 1-.3 1-.8 0-.6-.5-1-1-1-.4 0-.8.4-.8 1zm1.5-6c0-.4-.3-.8-.7-.8-.4 0-.8.4-.8.8v3c0 .4.4.8.8.8s.8-.4.8-.8V5zM2 8c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6z"}));
}

Exclamation.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Exclamation;

Exclamation.default = Exclamation;
